<mat-toolbar class="header p-0 p-sm-2 mat-toolbar-multiple-rows">
    <mat-toolbar-row>
        <a class="log-tag" [routerLink]="homePage()">
            <img title="Alabama Certification for Educators" class="fw-header__logo" id="desktop-log"
                src="../assets/logo-full.png" />
            <img title="Alabama Certification for Educators" class="fw-header__logo" id="phone-log"
                src="../assets/logo-profile.png" />
        </a>
        <span class="example-spacer"></span>

        <button mat-button class="header-button" color="primary" [routerLink]="homePage()">
            <span class="material-symbols-outlined pt-2">dashboard</span>
        </button>
        <button mat-button class="header-button" color="primary" [routerLink]="['/app/message-center']">
            <span class="material-symbols-outlined pt-2">mail</span>
        </button>
        <button mat-button class="header-button" color="primary" aria-label="Help"
            (click)="navigate('/app/help')">
            <span class="material-symbols-outlined pt-2">help</span>
        </button>
        <button mat-button class="header-button" color="primary" aria-label="Make a Payment"
            [routerLink]="['/app/standalone-payment']" *ngIf="getUser().alsdeId">
            <span class="material-symbols-outlined pt-2">attach_money</span>
        </button>

        <div class="d-none d-md-block" *ngIf="getUser().alsdeId">
            <span style="border-left: 2px solid #15204A;" class="px-2">Hi {{ getUser().firstName }}</span>
            <!-- <select class="form-select form-select-sm- py-0" style="display: inline;width: auto;" (change)="changeRoleWiseDashboard()"
                [(ngModel)]="getUser().selectedSiteRole">
                <option [ngValue]="siteRole" *ngFor="let siteRole of getUser().siteRoles">
                    {{siteRole.RoleName}}<span *ngIf="siteRole.SiteName"> - </span>{{siteRole.SiteName}}
                </option>
            </select> -->
        </div>
        <button mat-button class="header-button" color="primary" aria-label="Menu" *ngIf="getUser().alsdeId"
            (click)="drawer.toggle()" style="min-width: unset !important; padding-right: 0px;">
            <mat-icon class="material-icons md-dark">menu</mat-icon>
        </button>
        <!-- <button mat-button class="header-button" color="primary" aria-label="Menu"
            [matMenuTriggerFor]="menu" style="min-width: unset !important; padding-right: 0px;">
            <mat-icon class="material-icons md-dark">menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <a *ngIf="getUser().alsdeId" [routerLink]="homePage()" mat-menu-item><mat-icon
                    color="accent">home</mat-icon>
                <span>Home</span></a>
            <a *ngIf="getUser().alsdeId" target="_blank" href="{{environment.externalUrl.alsdeUserProfile}}"
                mat-menu-item><mat-icon color="accent">person</mat-icon>
                <span>User Profile (AIM)</span></a>
            <a *ngIf="getUser().alsdeId" [routerLink]="['/app/message-center']" mat-menu-item><mat-icon
                    color="accent">email</mat-icon>
                <span>Message Center</span></a>
            <button *ngIf="getUser().alsdeId" (click)="logout()" mat-menu-item><mat-icon
                    color="accent">logout</mat-icon>
                <span>Logout</span></button>
            <a *ngIf="!getUser().alsdeId" [routerLink]="['/app/auth/login']" (click)="login()" mat-menu-item><mat-icon
                    color="accent">login</mat-icon>
                <span>Login</span></a>
        </mat-menu> -->
    </mat-toolbar-row>
</mat-toolbar>
<app-banner></app-banner>
<mat-drawer-container class="right-sidenav-container" autosize>
    <mat-drawer #drawer class="right-sidenav-content" position="end">
        <button (click)="drawer.toggle()" class="btn" style="position: absolute;right: 10px;top: 10px;background: transparent;">x</button>
        <div class="d-flex flex-column">
            <div class="p-2">
                <span class="h2 m-0">Hi {{ getUser().firstName }}</span>
            </div>
            <div class="p-2">
                <span>ALSDE ID: {{ getUser().alsdeId }}</span>
            </div>
            <div class="p-2 role-select-container">
                <mat-select [(ngModel)]="getUser().selectedSiteRole" [compareWith]="compareSiteRoles"
                    (selectionChange)="changeRoleWiseDashboard()" panelClass="role-select-panel">
                    <mat-select-trigger>
                        <span class="role-trigger-name">{{getRoleDisplayName(getUser().selectedSiteRole?.RoleName)}}</span>
                        <span class="role-trigger-site" *ngIf="getUser().selectedSiteRole?.SiteName">{{getUser().selectedSiteRole.SiteName}}</span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let siteRole of getUser().siteRoles" [value]="siteRole">
                        <span class="role-option-name">{{getRoleDisplayName(siteRole.RoleName)}}</span>
                        <span class="role-option-site" *ngIf="siteRole.SiteName">{{siteRole.SiteName}}</span>
                    </mat-option>
                </mat-select>
            </div>
            <div class="px-2">
                <a *ngIf="getUser().alsdeId" target="_blank" href="{{environment.externalUrl.alsdeUserProfile}}" class="text-decoration-none px-2 body-title btn">
                    <mat-icon class="mat-icon-middle me-2 material-symbols-outlined">person</mat-icon>
                    <span>User Profile (AIM)</span>
                </a>
            </div>
            <div class="px-2">
                <a *ngIf="getUser().alsdeId" (click)="util.gotToFieldPrint()" class="text-decoration-none px-2 body-title btn">
                    <mat-icon class="mat-icon-middle me-2 material-symbols-outlined">verified_user</mat-icon>
                    <span>Fieldprint</span>
                </a>
            </div>
            <div class="px-2">
                <a *ngIf="getUser().alsdeId" [routerLink]="homePage()" class="text-decoration-none px-2 body-title btn">
                    <span class="material-symbols-outlined mat-icon-middle me-2">dashboard</span>
                    <span>Dashboard</span>
                </a>
            </div>
            <div class="px-2">
                <a *ngIf="getUser().alsdeId" target="_blank" [routerLink]="['/app/message-center']" class="text-decoration-none px-2 body-title btn">
                    <span class="material-symbols-outlined mat-icon-middle me-2">mail</span>
                    <span>Message Center</span>
                </a>
            </div>
            <div class="px-2">
                <a *ngIf="getUser().alsdeId" [routerLink]="['/app/standalone-payment']" class="text-decoration-none px-2 body-title btn">
                    <span class="material-symbols-outlined mat-icon-middle me-2">attach_money</span>
                    <span>Make a Payment</span>
                </a>
            </div>
            <div class="px-2">
                <a *ngIf="getUser().alsdeId" (click)="navigate('/app/help')" class="text-decoration-none px-2 body-title btn">
                    <span class="material-symbols-outlined mat-icon-middle me-2">help</span>
                    <span>Help</span>
                </a>
            </div>
            <div class="px-2">
                <a *ngIf="getUser().alsdeId" (click)="logout()" class="text-decoration-none px-2 body-title btn">
                    <mat-icon class="mat-icon-middle me-2">logout_outline</mat-icon>
                    <span>Logout</span>
                </a>
            </div>
        </div>
    </mat-drawer>
</mat-drawer-container>
